export default "__VITE_ASSET__DEucnzut__"